define('bizzabo/views/UploadFileView',[
    'backbone',
    'underscore',
    'bizzabo/consts',
    'bizzabo/config',
    'bizzabo/bzapi',
    'hbars!bizzabo/templates/uploadFile'
], function(
    Backbone,
    _,
    Consts,
    CONFIG,
    BZAPI,
    template
    ) {

    var UploadFileView = Backbone.View.extend({

        events : {
            'change input[type=file]' : 'submit'
        },

        initialize : function(options) {
            _.bindAll(this, 'submit', 'setErrorMessage');

            this.model = new Backbone.Model({
                actionURL : CONFIG.SERVER_URL + '/api/v1' + (options.actionURL ? options.actionURL : '/images/upload'),
                fileAcceptType : (options.fileAcceptType || 'image/*'),
                description : (options.description || 'Recommended size: 400W X 260H. Must be JPG, GIF, or PNG and smaller than 750Kb'),
                uploadZone : options.uploadZone
            });
        },

        remove : function() {
            this.detach();
            this.$el.remove();
        },

        uploadZoneClicked :function() {
            this.$('.inputTypeFile').click();
        },

        render : function() {
            var html = template(this.model.toJSON());
            this.$el.html(html);

            return this;
        },

        setLoading : function(isLoading) {
            if (isLoading) {
                this.setErrorMessage('');
                this.$('.loading').removeClass('hide');
                this.$('.customUploadButton .button').addClass('disabled');
            } else {
                this.$('.loading').addClass('hide');
                this.$('.customUploadButton .button').removeClass('disabled');
                this.$('#frmUpload').get(0).reset();
            }
        },

        setErrorMessage : function(message) {
            this.$('p.error').html(message);
        },

        isValidFileName : function(fileName) {
            if (this.model.get('fileAcceptType') != 'image/*') {
                return true;
            }

            return (/\.png$/i.test(fileName) || /\.jpg$/i.test(fileName) || /\.jpeg$/i.test(fileName) || /\.gif$/i.test(fileName));
        },

        submit : function(evt) {
            evt.preventDefault();
            var errorMsgs = {
                FILE_SIZE_LIMIT_REACHED : 'File is too big',
                UNSPECIFIED_SERVER_ERROR : 'Upload failed',
                DEFAULT : 'Upload failed'
            };

            var fileName = this.$('input[type=file]').val();
            if (_.isEmpty(fileName)) {
                return false;
            }
            if (!this.isValidFileName(fileName)) {
                if (!this.model.uploadZone) {
                    this.setErrorMessage(errorMsgs['CONTENT_VALIDATION_ERROR']);
                }
                this.trigger('error', errorMsgs['CONTENT_VALIDATION_ERROR']);
                return false;
            }
            if (!this.model.uploadZone) {
                this.setLoading(true);
            }
            this.trigger('started');

            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Responses',
                action : 'File uploaded'
            });

            var formNode = this.$('#frmUpload').get(0)[0];
            var formData = new FormData();
            var parseResponseToJson = function(response) {
                try {
                    return JSON.parse(response.split('parent.rpc.returnUploadResponse(')[1].split(');')[0]);
                } catch (e) {
                    throw new Error('Invalid agenda upload response');
                }
            };
            formData.append('upload_file', formNode.files[0]);
            var thisView = this;
            $.ajax({
                url: thisView.model.get('actionURL'),
                method: 'POST',
                headers: {
                    Authorization: 'Bizzabo token="' + BZAPI.token() + '"',
                    'Accept': '*'
                },
                data: formData,
                processData: false,
                contentType: false,
                timeout: 10 * 60 * 1000,
                success: function(response) {
                    var json = parseResponseToJson(response);
                    (!thisView.model.uploadZone) && thisView.setLoading(false);
                    thisView.trigger('success', json);
                },
                error: function(response) {
                    var json = parseResponseToJson(response);
                    var errorCode = (json && json.error && json.error['error-code']);
                    var errorMsg;
                    if (errorCode === 'CONTENT_VALIDATION_ERROR') {
                        errorMsg = json.error.message;
                    }
                    else{
                        errorMsg = errorMsgs[errorCode] || (errorMsgs['DEFAULT']);
                    }
                    if (!thisView.model.uploadZone) {
                        thisView.setLoading(false);
                        thisView.setErrorMessage(errorMsg);
                    }
                    thisView.trigger('error', errorMsg, json);
                }
            });
        },

        attachTo: function(zone, uploadElement, beforeElement) {
            this.detach();
            this.model.set('zone-element', zone);
            this.model.set('upload-element', uploadElement);
            if (beforeElement) {
                beforeElement.before(uploadElement);
            } else {
                zone.append(uploadElement);
            }

            var handler = function(e) {
                var offset = (-10);
                var zoneOffset = zone.offset();
                var left = offset + e.clientX - zoneOffset.left;
                var top = offset + e.clientY - zoneOffset.top + $(window).scrollTop();
                left = Math.min(Math.max(left, 0), zone.width() - uploadElement.width());
                top = Math.min(Math.max(top, 0), zone.height());
                uploadElement.css({
                    'top' : top + 'px',
                    'left' : left + 'px'
                });
            };

            zone.mouseenter(function(e) {
                zone.bind('mousemove', handler);
            });
            zone.mouseleave(function(e) {
                zone.unbind('mousemove', handler);
                uploadElement.css({
                    'top' : '0',
                    'left' : '0'
                });
            });
        },

        detach : function() {
            if (this.model.has('zone-element')) {
                this.model.get('zone-element').unbind('mouseenter').unbind('mouseleave');
            }
            this.model.unset('zone-element');
            this.model.unset('upload-element');
        }


    });

    return UploadFileView;

});

